import { lazy } from "common/load/componentUtils";

import { useDrawer } from "client/common/hooks/stackables";

import { AppointmentBookingAlertDrawerProps } from "../types/stackables";

const AppointmentBookingAlertDrawer = lazy(
  () => import("../components/AppointmentBookingAlertDrawer"),
);

export const useAppointmentBookingAlertDrawer = () => {
  const { open } = useDrawer();
  return {
    open: (props: AppointmentBookingAlertDrawerProps) => open(AppointmentBookingAlertDrawer, props),
  };
};
